









































import {
  GridColumn,
  GridForm,
  GridRow,
} from '@/components/grid';
import ShowGuide from '@/components/ShowGuide.vue';
import WashIcons from '@/components/wash-icons/WashIcons.vue';

export default {
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    GridColumn,
    GridForm,
    GridRow,
    ShowGuide,
    WashIcons,
  },
} as IView;
